<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-introduction element-without-heading" id="introduction">
<div class="text" id="introduction-text">
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/break.jpg"/>
</div>
</div>
<div class="inline-image inline-image-kind-freestanding inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-with-caption inline-image-after-section-begin">
<div class="inline-image-container">
<img alt="" src="images/my-project-1.jpg"/>
</div>
<p class="inline-image-caption">Star People and the Jane Ellen</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?f555abda